import * as marietta from '../..';

class ScrollSettingCollection {
    scale: number;

    x: number;

    y: number;

    /**
     * コンストラクタ
     */
    constructor(x: number = NaN, y: number = NaN, scale: number = NaN) {
      this.x = x;
      this.y = y;
      this.scale = scale;
    }

    /**
     * クローン
     * @return marietta.webcad.collection.PointCollection
     */
    clone(): marietta.webcad.collection.ScrollSettingCollection {
      return new marietta.webcad.collection.ScrollSettingCollection(this.x, this.y, this.scale);
    }

    /**
     * ポイント情報の取得
     * */
    get point(): marietta.core.Point { return new marietta.core.Point(this.x, this.y); }
}
export default ScrollSettingCollection;
